<template>
  <v-row
    v-if="currentPageName === 'dashboard'"
    class="ma-0"
  >
    <v-col
      v-if="selectedSearch"
      class="pt-0"
    >
      <v-row
        class="justify-space-between align-self-start mt-0"
      >
        <dashboard-bar />
      </v-row>

      <v-row
        v-if="isInternalUser"
        class="mt-0 pa-2"
      >
        <v-col class="col-12 col-sm-12 col-md-4 pa-2">
          <v-card class="elevation-0">
            <v-card-title class="subtitle-2 font-weight-bold">
              <v-col class="pa-0">
                Organization
              </v-col>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-col>
                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Billing Code</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <span class="body-2 font-weight-medium">{{ selectedSearch.billingCode }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">GAM Network</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <a
                      :href="selectedSearch.adServerUrl"
                      target="_blank"
                    >
                      <span class="body-2 font-weight-medium">{{ selectedSearch.networkCode }}</span>
                    </a>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">GAM Teams</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <span class="body-2 font-weight-medium">{{ (selectedSearch.hasTeam && 'Enabled') || 'Disabled' }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Active</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <span class="body-2 font-weight-medium">{{ (selectedSearch.isActive && 'Yes') || 'No' }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Billable</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <span class="body-2 font-weight-medium">{{ (selectedSearch.isTimesheetEnabled && 'Yes') || 'No' }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Aliases</span>
                  </v-col>

                  <v-col class="py-0 pl-0">
                    <span class="body-2 font-weight-medium">{{ aliases }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="col-12 col-sm-12 col-md-4 pa-2">
          <v-card class="elevation-0">
            <v-card-title class="subtitle-2 font-weight-bold">
              <v-col class="pa-0">
                Reports
              </v-col>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-col>
                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasPacingReport.color"
                      :title="hasPacingReport.value"
                      small
                    >
                      {{ hasPacingReport.icon }}
                    </v-icon>

                    <span class="outline">Pacing</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasDiscrepancyReport.color"
                      :title="hasDiscrepancyReport.value"
                      small
                    >
                      {{ hasDiscrepancyReport.icon }}
                    </v-icon>

                    <span class="outline">Discrepancy</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasHealthAdxReport.color"
                      :title="hasHealthAdxReport.value"
                      small
                    >
                      {{ hasHealthAdxReport.icon }}
                    </v-icon>

                    <span class="outline">AdX Health</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasHealthNetworkReport.color"
                      :title="hasHealthNetworkReport.value"
                      small
                    >
                      {{ hasHealthNetworkReport.icon }}
                    </v-icon>

                    <span class="outline">Network Health</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasYieldPartnerReport.color"
                      :title="hasYieldPartnerReport.value"
                      small
                    >
                      {{ hasYieldPartnerReport.icon }}
                    </v-icon>

                    <span class="outline">AdX & OB</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col :class="`py-0 pl-0 font-weight-medium ${titleColor}--text`">
                    <v-icon
                      class="pr-1"
                      :color="hasCustomAnalytics.color"
                      :title="hasCustomAnalytics.value"
                      small
                    >
                      {{ hasCustomAnalytics.icon }}
                    </v-icon>

                    <span class="outline">Custom Analytics</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="col-12 col-sm-12 col-md-4 pa-2">
          <v-card class="elevation-0">
            <v-card-title>
              <v-col class="pa-0 subtitle-2 font-weight-bold">
                <span>Time</span>
              </v-col>

              <v-spacer />

              <v-col class="py-0 subtitle-2 coolgray--text text-right">
                <span>Month-to-Date</span>
              </v-col>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-col>
                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Total</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries.TOTAL"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries.TOTAL.totalFormatted }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Billable</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries.BILLABLE"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries.BILLABLE.totalFormatted }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Non-Billable</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries['NON-BILLABLE']"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries['NON-BILLABLE'].totalFormatted }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">Project</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries.PROJECT"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries.PROJECT.totalFormatted }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">AdX</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries.ADX"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries.ADX.totalFormatted }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 pl-0">
                    <span :class="`body-2 font-weight-medium ${titleColor}--text`">AdX-PG</span>
                  </v-col>

                  <v-col class="py-0 pl-0 text-right">
                    <v-skeleton-loader
                      v-if="!timeSummaries || !timeSummaries['ADX-PG']"
                      type="text"
                      class="body-2 font-weight-medium"
                    />
                    <span
                      v-else
                      class="body-2 font-weight-medium"
                    >{{ timeSummaries['ADX-PG'].totalFormatted }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-if="customDashboards && customDashboards.length"
        class="mt-0 align-self-start"
      >
        <v-col
          v-for="(customDashboard, customDashboardIndex) in customDashboards"
          :key="customDashboardIndex"
          :class="`col-${twoColumnLayout[customDashboardIndex]}`"
        >
          <v-card
            class="pa-0 elevation-0 mt-0"
          >
            <v-card-title class="subtitle-2 font-weight-bold py-0">
              <v-col class="pa-0">
                <span>{{ customDashboard.name }}</span>
              </v-col>

              <v-col class="text-right">
                <v-btn
                  class="elevation-0"
                  icon
                >
                  <v-icon
                    small
                  >
                    refresh
                  </v-icon>
                </v-btn>
              </v-col>
            </v-card-title>

            <v-divider />

            <connected-app
              :custom-analytics="customDashboard"
              :device="deviceCategoryName"
              :hide-tabs="true"
              toolbar="hidden"
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-if="isInternalUser"
        class="mt-0 pa-2"
      >
        <v-col class="pa-2">
          <v-card class="elevation-0">
            <v-card-title class="subtitle-2 font-weight-bold nearblack--text">
              <v-col class="py-0">
                Persons
              </v-col>

              <v-spacer />

              <v-text-field
                v-model="searchPersons"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                class="pt-0 mt-0"
              />
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-data-table
                :headers="userHeaders"
                :items="users"
                :items-per-page="5"
                class="elevation-0"
                :search="searchPersons"
              >
                <template v-slot:item.access.active="{ item }">
                  <v-icon
                    :color="(item.access.active && 'offblue') || 'coolgray'"
                    :readonly="true"
                  >
                    {{ (item.access.active && 'check') || 'remove' }}
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      v-else
      class="ma-4"
    >
      <v-row>
        <v-col>
          <v-row>
            <h2>Networks</h2>
          </v-row>

          <v-row>
            <p>Manage your networks.</p>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-list>
          <v-list-item
            v-for="network in networks"
            :key="network.reportCode"
            link
          >
            <v-list-item-content>
              <v-list-item-title>
                <router-link :to="network.href">
                  {{ network.reportLabel }}
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters, mapState: mapLayoutState } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'Dashboard',
  components: {
    DashboardBar: () => import('src/dashboard/components/DashboardBar'),
    ConnectedApp: () => import('src/custom-analytics/components/ConnectedApp'),
  },
  data() {
    return {
      personAssignments: {},
      searchPersons: '',
      timeSummaries: {},
    }
  },
  computed: {
    ...mapAuthGetters(['isActiveUser', 'isInternalUser']),
    ...mapLayoutGetters(['clearColor', 'titleColor']),
    ...mapLayoutState({
      icons: (state) => state.icons,
    }),
    ...mapToolsGetters([
      'currentPageName',
      'networks',
      'persons',
      'selectedSearch',
    ]),
    deviceCategoryName() {
      const { lgAndUp, name: breakpointName, smAndUp } = this.$vuetify.breakpoint
      const mobile = () => breakpointName === 'xs' && 'mobile'
      const tablet = () => smAndUp && 'desktop'
      const desktop = () => lgAndUp && 'desktop'

      return desktop() || tablet() || mobile() || 'desktop'
    },
    threeColumnLayout() {
      const { name: breakpointName } = this.$vuetify.breakpoint
      const breakpointMap = {
        sm: [12, 12, 12],
        md: [4, 4, 4],
        lg: [4, 4, 4],
        xl: [4, 4, 4],
      }
      return breakpointMap[breakpointName]
    },
    twoColumnLayout() {
      const { name: breakpointName } = this.$vuetify.breakpoint
      const breakpointMap = {
        xs: [12, 12],
        sm: [12, 12],
        md: [8, 4],
        lg: [8, 4],
        xl: [8, 4],
      }
      return breakpointMap[breakpointName]
    },
    organization() {
      return this.selectedSearch
    },
    valueIcons() {
      return this.icons.values
    },
    customDashboards() {
      const dashboards = this.organization?.access?.permissions?.dashboards
      return dashboards && Array.isArray(dashboards) && dashboards.filter((dashboard) => dashboard.active === true)
    },
    users() {
      const { personAssignments, persons, selectedSearch } = this
      const { billingCode } = selectedSearch
      const { assignments } = personAssignments || {}
      const havePersonAssignments = assignments && assignments.length > 0

      return persons.filter((person) => person.billingCodes.indexOf(billingCode) !== -1).map((person) => {
        const foundAssignment = havePersonAssignments && assignments.find((assignment) => assignment.personId === person.personId)

        if (foundAssignment && foundAssignment.activeRoleAssignment) {
          person.assignment = foundAssignment.roleName
        }

        return person
      })
    },
    userHeaders() {
      return [
        {
          text: 'Name',
          value: 'personName',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Active',
          value: 'access.active',
        },
        {
          text: 'Access Role',
          value: 'access.role',
        },
        {
          text: 'Assignment',
          value: 'assignment',
        },
      ]
    },
    aliases() {
      const aliases = this.selectedSearch.aliases || [{ active: true, value: 'None' }]
      return aliases.map((alias) => alias.value).join(', ')
    },
    hasPacingReport() {
      const { organization = {}, valueIcons } = this
      const { hasPacing: value, hasPacingReport = false } = organization
      const propertyName = String(hasPacingReport, 'Error at hasPacingReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value }
    },
    hasDiscrepancyReport() {
      const { organization = {}, valueIcons } = this
      const { hasDiscrepancy: booleanValue, hasDiscrepancyReport = false } = organization
      const propertyName = String(hasDiscrepancyReport, 'Error at hasDiscrepancyReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value: booleanValue }
    },
    hasHealthAdxReport() {
      const { organization = {}, valueIcons } = this
      const { hasHealthAdx: value, hasHealthAdxReport = false } = organization
      const propertyName = String(hasHealthAdxReport, 'Error at hasHealthAdxReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value }
    },
    hasHealthNetworkReport() {
      const { organization = {}, valueIcons } = this
      const { hasHealthNetwork: value, hasHealthNetworkReport = false } = organization
      const propertyName = String(hasHealthNetworkReport, 'Error at hasHealthNetworkReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value }
    },
    hasYieldPartnerReport() {
      const { organization = {}, valueIcons } = this
      const { hasProgrammatic: value, hasYieldPartnerReport = false } = organization
      const propertyName = String(hasYieldPartnerReport, 'Error at hasYieldPartnerReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value }
    },
    hasCustomAnalytics() {
      const { organization = {}, valueIcons } = this
      const { hasCustomAnalytics: value, hasCustomAnalyticsView = false } = organization
      const propertyName = String(hasCustomAnalyticsView, 'Error at hasYieldPartnerReport at dashboard').toLowerCase()

      const styles = valueIcons[propertyName] || {}

      return { ...styles, value }
    },
  },
  watch: {
    selectedSearch: {
      deep: true,
      handler(newValue, oldValue) {
        const hasChanged = () => newValue && oldValue && newValue.associationId !== oldValue.associationId
            && newValue.baseReportName !== oldValue.baseReportName
            && newValue.reportPath !== oldValue.reportPath
            && newValue.routeName !== oldValue.routeName
            && newValue.subId !== oldValue.subId
        const hasChangedValue = () => newValue !== oldValue || hasChanged()

        if (newValue && hasChangedValue()) {
          const selectedSearch = newValue || {}
          this.updateTimeSummaries(selectedSearch)
          this.updatePersonAssignments(selectedSearch)
        }
      },
    },
  },
  methods: {
    async updateTimeSummaries(selectedSearch) {
      this.timeSummaries = null

      const { associationId, baseReportName, billingCode, reportPath, routeName, teamId, subId } = selectedSearch
      const params = { baseReportName, routeName }
      const query = { associationId, billingCode, reportPath, subId, teamId }

      this.timeSummaries = await this.$store.dispatch('dashboard/getTimeCard', { params, query })
    },
    async updatePersonAssignments(selectedSearch) {
      this.personAssignments = null

      const { associationId, baseReportName, billingCode, reportPath, routeName, teamId, subId } = selectedSearch
      const params = { baseReportName, routeName }
      const query = { associationId, billingCode, reportPath, subId, teamId }

      this.personAssignments = await this.$store.dispatch('dashboard/getPersonsCard', { params, query })
    },
  },
}
</script>
